module.exports = {"helmetTitle":"Minha Veloe - Histórico de VeloeTag","tag":"Tag","papText":"PONTO A PONTO:","operacao":{"ATIVAR":"Ativado","INATIVAR":"Inativado","BLOQUEAR":"Bloqueado","DESBLOQUEAR":"Desbloqueado","ALTERAR_PLACA":"Alteração de placa","ALTERAR_CATEGORIA":"Alteração de categoria","SUBSTITUIR":"Substituído"}}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/DashboardIdentifiersHistory/data.json
// module id = 2025
// module chunks = 0